export const mifeName = '@mife/version-one';
